(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v1-split-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(section) {
    var grid = section.querySelector('.v1-hero__grid');
    var columns = section.querySelectorAll('.v1-hero__column');
    if (!grid || columns.length === 0) return;

    // Inject dots after the grid
    if (!section.querySelector('.v1-hero__dots')) {
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'v1-hero__dots';
      dotsWrap.setAttribute('aria-hidden', 'true');
      for (var j = 0; j < columns.length; j++) {
        var dot = document.createElement('span');
        dot.className = 'v1-hero__dot' + (j === 0 ? ' v1-hero__dot--active' : '');
        dotsWrap.appendChild(dot);
      }
      grid.parentNode.insertBefore(dotsWrap, grid.nextSibling);
    }

    var dots = section.querySelectorAll('.v1-hero__dot');
    var ticking = false;
    grid.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        var gridLeft = grid.getBoundingClientRect().left;
        var bestIdx = 0;
        var bestDiff = Infinity;
        for (var k = 0; k < columns.length; k++) {
          var diff = Math.abs(columns[k].getBoundingClientRect().left - gridLeft);
          if (diff < bestDiff) {
            bestDiff = diff;
            bestIdx = k;
          }
        }
        for (var m = 0; m < dots.length; m++) {
          if (m === bestIdx) {
            dots[m].classList.add('v1-hero__dot--active');
          } else {
            dots[m].classList.remove('v1-hero__dot--active');
          }
        }
        ticking = false;
      });
    }, { passive: true });
  }

  function initAll() {
    var sections = document.querySelectorAll('.v1-hero');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v1-testimonials"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCarousel(section) {
    var viewport = section.querySelector('.v1-test__viewport');
    var track = section.querySelector('.v1-test__track');
    var slides = section.querySelectorAll('.v1-test__slide');
    var prev = section.querySelector('.v1-test__arrow--prev');
    var next = section.querySelector('.v1-test__arrow--next');
    var dotsContainer = section.querySelector('.v1-test__dots');
    if (!track || slides.length === 0) return;

    var pageIndex = 0;
    var slidesPerView = computeSlidesPerView();
    var pageCount = Math.ceil(slides.length / slidesPerView);

    function computeSlidesPerView() {
      return window.matchMedia('(max-width: 768px)').matches ? 1 : 3;
    }

    function update() {
      var offset = -(pageIndex * 100);
      track.style.transform = 'translateX(' + offset + '%)';

      var dots = dotsContainer.querySelectorAll('.v1-test__dot');
      for (var i = 0; i < dots.length; i++) {
        var isActive = i === pageIndex;
        dots[i].classList.toggle('is-active', isActive);
        dots[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
      }

      if (prev) prev.disabled = pageIndex === 0;
      if (next) next.disabled = pageIndex >= pageCount - 1;

      section.classList.toggle('v1-test--single', pageCount <= 1);
    }

    function buildDots() {
      dotsContainer.innerHTML = '';
      if (pageCount <= 1) return;
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'v1-test__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Page ' + (i + 1));
        (function(idx) {
          dot.addEventListener('click', function() {
            pageIndex = idx;
            update();
          });
        })(i);
        dotsContainer.appendChild(dot);
      }
    }

    function goPrev() {
      if (pageIndex > 0) { pageIndex--; update(); }
    }
    function goNext() {
      if (pageIndex < pageCount - 1) { pageIndex++; update(); }
    }

    if (prev) prev.addEventListener('click', goPrev);
    if (next) next.addEventListener('click', goNext);

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        var newSPV = computeSlidesPerView();
        if (newSPV !== slidesPerView) {
          slidesPerView = newSPV;
          pageCount = Math.ceil(slides.length / slidesPerView);
          pageIndex = Math.min(pageIndex, pageCount - 1);
          buildDots();
          update();
        }
      }, 150);
    });

    var touchStartX = 0;
    var touchStartY = 0;
    viewport.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    viewport.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) goNext();
        else goPrev();
      }
    }, { passive: true });

    buildDots();
    update();
  }

  function initAll() {
    var sections = document.querySelectorAll('.v1-test');
    for (var i = 0; i < sections.length; i++) initCarousel(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
